<template>
	<EMCoreTemplate category="OSMLife" identity="policy" entity="osm_policy"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/Policy.vue